import {borderRadius, fontsSize} from "./UIElements/Elements";

const MenuItem = ({key, id, productName, price, onClick}) => {
    return (
        <div id={key}
             className={`flex flex-col w-[10vw] justify-center items-center relative m-[0.25vh] h-auto bg-cyan-800 ${borderRadius.medium} px-[2vh] py-[2vh] ${fontsSize.m} 
              max-lg:w-[19%] max-lg:h-[7vh] max-lg:m-[0.5%] max-lg:py-0`}
             onClick={onClick}>
            <div className={`${fontsSize.s} text-white font-bold overflow-hidden leading-[2vh] text-center`}>{productName}</div>
            <div className={`${fontsSize.s} max-lg:hidden text-white`}>{`${price} den`}</div>
        </div>
    );
};

export default MenuItem;
